import {h} from 'preact';
import cx from 'classnames';

const Message = ( {children, className, processing, fail, success, ...props} ) =>
    <div className={cx(
        'message-bar p-4 text-near-white font-normal rounded',
        {processing, fail, success},
        className
    )}
         {...props}>{children}</div>;

export default Message;